(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function openModal(id) {
      var dialog = document.getElementById(id);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    function closeModal(dialog) {
      if (dialog && typeof dialog.close === 'function') {
        dialog.close();
      }
    }

    document.addEventListener('click', function (event) {
      // Open via trigger button
      var trigger = event.target.closest('[data-modal-id]');
      if (trigger) {
        openModal(trigger.getAttribute('data-modal-id'));
        return;
      }

      // Close via close button
      var closeBtn = event.target.closest('.modal__close');
      if (closeBtn) {
        closeModal(closeBtn.closest('.modal__dialog'));
        return;
      }

      // Close on backdrop click (click outside dialog inner content)
      if (event.target.classList.contains('modal__dialog')) {
        closeModal(event.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
